import { bool, number, shape, string } from 'prop-types'
import type { AnyAction } from 'redux'

import {
  SHIPPING_OPTIONS_RESET_EVENT,
  SHIPPING_OPTIONS_TOGGLE_EVENT,
} from 'shared/experiments/components/NewSerp/ShippingOptions/consts'
import { type DisplayableFacetName } from 'types/search'
import { SHIPPING_OPTIONS_FILTER_NAME } from 'views/components/organisms/AlgoliaInstantSearch/ProductFilter/consts'

export const CategoryListItemType = shape({
  label: string,
  value: string,
  count: number,
  level: number,
  hideCount: bool,
  isRefined: bool,
})

export const RefinementListItemType = shape({
  id: string,
  label: string,
  value: string,
  isRefined: bool,
  count: number,
})

/**
 * Refinement item that comes in a collection from the connected control
 */
export type RefItem = {
  count: number
  isRefined: boolean
  label: string
  value: string
}

/**
 * Parsed item that will be rendered in a component
 */
export type CategoryItem = {
  level: number
  hideCount?: boolean
} & RefItem

export type ShippingOptionAttribute = 'nowProductGroup' | 'filterAttributes'

export type ShippingOptionType = {
  id: string
  attribute: ShippingOptionAttribute
  label: string
  customRefinementGroupName: typeof SHIPPING_OPTIONS_FILTER_NAME
  value: string
  nowLabel?: boolean
  aboLabel?: boolean
}

export type ShippingOptionToggleAction =
  | {
      attribute: ShippingOptionAttribute
      refine: CallableFunction
      type: typeof SHIPPING_OPTIONS_TOGGLE_EVENT
      value: boolean
    }
  | AnyAction

export type ShippingOptionResetAction =
  | {
      type: typeof SHIPPING_OPTIONS_RESET_EVENT
      attribute: ShippingOptionAttribute
    }
  | AnyAction

export type RefinementListChangeAction =
  | {
      type: string
      selected: string
      isChecked: boolean
    }
  | AnyAction

export type RefinementListCloseAction =
  | {
      type: string
      attribute: DisplayableFacetName
    }
  | AnyAction
